<template>
	<div>
		<h1 class="mt-0 mb-5">Manage My Profile</h1>

		<div class="profile-section">
			<div class="row">
				<div class="col-xs-12 col-md-6">
					<profile-form />
				</div>

				<div class="col-xs-12 col-md-6">
					<password-form />
				</div>
			</div>
		</div>

		<div class="profile-section">
			<address-list />
		</div>

		<div class="profile-section">
			<payment-method-list />
		</div>

	</div>
</template>

<script>
import requireUserLogin from 'frontend/shared/require-user-login';

import AddressList from './AddressList.vue';
import PaymentMethodList from './PaymentMethodList.vue';
import ProfileForm from './ProfileForm.vue';
import PasswordForm from './PasswordForm.vue';
//import OrderList from './OrderList.vue';

export default {
	mixins: [requireUserLogin],
	components: { AddressList, PaymentMethodList, ProfileForm, PasswordForm },
}
</script>

<style scoped>
.profile-section
{
	margin-bottom: 40px;
}
</style>